import React from 'react'
import PropTypes from 'prop-types'

const DhsvClientAdItem = ({ row, data, list }) => {
  //console.log(data.bgcolor_picker) //eslint-disable-line
  return (
    <div
      //style={{ backgroundColor: data.bgcolor_picker }}
      //style={{ color: 'red' }}
      className={
        `blog-item client-advertisement` +
        (!['magazin_2_spalten_left', 'magazin_2_spalten_right'].includes(row)
          ? ' small'
          : '')
      }
    >
      <div className="inner">
        {list ? (
          <div
            className="image lazyload"
            {...(data.thumbnail ? { 'data-bg': data.thumbnail } : {})}
          />
        ) : (
          <a
            href={data.link.url}
            className="image lazyload"
            {...(data.thumbnail ? { 'data-bg': data.thumbnail } : {})}
          />
        )}
      </div>
    </div>
  )
}

DhsvClientAdItem.propTypes = {
  row: PropTypes.string,
  data: PropTypes.object,
  list: PropTypes.bool,
}

export default DhsvClientAdItem
